import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIResource } from "../../constants/application";
import { getUrl } from "utils/getURL";
import axiosInstance from "utils/axiosInstance";
import { AppSpecificName } from "constants/headerImage";

interface ISubmitKYC {
  nameMismatchReason: string;
  customerSource:string;
}

export const submitKYC = createAsyncThunk(
  "submitKYC",
  async (data: ISubmitKYC, thunkAPI) => {
    const state = thunkAPI.getState() as {
      info: { allData: { customerId: string } };
    };
    try {
      const appName:any = localStorage.getItem('appname');
      data['customerSource'] = AppSpecificName[appName];

      const response = await axiosInstance.put(
        getUrl(APIResource.submitKYC, [
          {
            variableName: "customerId",
            variableValue: state?.info?.allData?.customerId,
          },
        ]),
        {
          ...data,
        }
      );
      if (response.status === 200) {
        if (response?.data?.error) {
          return thunkAPI.rejectWithValue("Error Occurred!");
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue("Error Occurred!");
    }
  }
);

const submitKYCSlice = createSlice({
  name: "submitKYCSlice",
  initialState: {
    loading: false,
    error: false,
    success: false,
  },
  reducers: {
    resetError: (state) => {
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(submitKYC.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    });
    builder.addCase(submitKYC.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });
    builder.addCase(submitKYC.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  },
});

// Export actions and reducer
export const { resetError } = submitKYCSlice.actions;

export default submitKYCSlice.reducer;
